import { motion } from "framer-motion";
import { PROCESS } from "../data/site";

const EASE = [0.16, 1, 0.3, 1];

export const ProcessJourney = () => {
    return (
        <div data-testid="process-journey" className="relative w-full">
            {/* Desktop: horizontal journey */}
            <div className="hidden md:block relative">
                <svg
                    viewBox="0 0 1200 200"
                    className="w-full h-[200px]"
                    preserveAspectRatio="none"
                    aria-hidden
                >
                    {/* Reference top/bottom lines */}
                    <motion.line
                        x1="0" y1="20" x2="1200" y2="20"
                        stroke="rgba(17,17,17,0.15)" strokeWidth="1" strokeDasharray="2 4"
                        initial={{ pathLength: 0 }}
                        whileInView={{ pathLength: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 1.4, ease: EASE }}
                    />
                    {/* Main pathway — gentle wave */}
                    <motion.path
                        d="M 40 100 C 220 60, 360 140, 540 100 S 860 60, 1040 100 L 1160 100"
                        fill="none"
                        stroke="#111111"
                        strokeWidth="1.25"
                        initial={{ pathLength: 0 }}
                        whileInView={{ pathLength: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 2.2, ease: EASE }}
                    />
                    {/* Milestones */}
                    {PROCESS.map((p, i) => {
                        const x = 40 + i * 280;
                        // approximate y on wave: alternate
                        const ys = [100, 78, 110, 86, 100];
                        const y = ys[i];
                        return (
                            <motion.g
                                key={p.n}
                                initial={{ opacity: 0, scale: 0.6 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{
                                    duration: 0.6,
                                    delay: 0.4 + i * 0.18,
                                    ease: EASE,
                                }}
                            >
                                <circle cx={x} cy={y} r="20" fill="white" stroke="#111111" strokeWidth="1" />
                                <circle cx={x} cy={y} r="28" fill="none" stroke="#111111" strokeWidth="1" strokeDasharray="2 4" opacity="0.4" />
                                <text
                                    x={x}
                                    y={y + 4}
                                    textAnchor="middle"
                                    style={{
                                        fontFamily: "Cormorant Garamond, serif",
                                        fontStyle: "italic",
                                        fontSize: "16px",
                                        fill: "#111111",
                                    }}
                                >
                                    {p.n}
                                </text>
                                <line x1={x} y1={y + 28} x2={x} y2={y + 50} stroke="#111111" strokeWidth="1" />
                            </motion.g>
                        );
                    })}
                    {/* Animated traveler */}
                </svg>

                {/* Labels under each milestone */}
                <div className="grid grid-cols-5 mt-2">
                    {PROCESS.map((p, i) => (
                        <motion.div
                            key={p.n}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: 0.8,
                                delay: 0.6 + i * 0.18,
                                ease: EASE,
                            }}
                            className="px-3 text-center"
                        >
                            <p className="text-[10px] tracking-[0.28em] uppercase text-[#444444]">
                                Stage {p.n}
                            </p>
                            <h3 className="mt-2 font-serif text-2xl text-[#111111] leading-tight">
                                {p.title}
                            </h3>
                            <p className="mt-3 text-sm text-[#444444] leading-relaxed max-w-[180px] mx-auto">
                                {p.body}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Mobile: vertical journey */}
            <ol className="md:hidden relative pl-10">
                <span className="absolute left-4 top-2 bottom-2 w-px bg-[#111111]/30" />
                {PROCESS.map((p, i) => (
                    <motion.li
                        key={p.n}
                        initial={{ opacity: 0, x: 12 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-40px" }}
                        transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
                        className="relative pb-10 last:pb-0"
                    >
                        <span className="absolute -left-10 top-0 w-8 h-8 rounded-full bg-white border border-[#111111] flex items-center justify-center font-serif italic text-sm">
                            {p.n}
                        </span>
                        <h3 className="font-serif text-2xl">{p.title}</h3>
                        <p className="mt-2 text-[#444444] text-sm leading-relaxed">
                            {p.body}
                        </p>
                    </motion.li>
                ))}
            </ol>
        </div>
    );
};
